export default [
  {
    path: '/audit-trail',
    name: 'audit-trail',
    component: () => import('@/views/audit-trail/Index.vue'),
    meta: {
      resource: 'Audit-Trail',
      action: 'read',
      pageTitle: 'Audit Trail',
      breadcrumb: [
        {
          text: 'Audit Trail',
          active: true
        }
      ],
    },
  }
]
